import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { MenuItem, TextField, Typography, Box } from "@mui/material";
import { useField } from "formik";
import { makeStyles } from "@mui/styles";

import axios from "../utils/axios";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 14,
    fontWeight: 600,
  },
  optional: {
    fontSize: 12,
    fontWeight: 400,
    color: "gray",
    marginLeft: 6,
  },
}));

export default function GenderField({
  name = "gender",
  label = "Gender",
  loading = false,
  required = false,
}) {
  const classes = useStyles();
  const [categories, setCategories] = useState([]);
  const [field, meta] = useField(name);

  useEffect(() => {
    axios
      .get("datahub/gender-categories")
      .then((response) => {
        setCategories(response?.data?.data?.categories || []);
      })
      .catch(() => {
        setCategories([]);
      });
  }, []);

  return (
    <Box>
      <Typography
        color={meta.touched && meta.error ? "error" : "text.primary"}
        gutterBottom
        className={classes.label}
      >
        {label}
        {required && "*"}
        {!required && (
          <Typography component="span" display="inline" className={classes.optional}>
            (optional)
          </Typography>
        )}
      </Typography>
      <TextField
        {...field}
        select
        fullWidth
        disabled={loading}
        value={field.value || ""}
        error={Boolean(meta.touched && meta.error)}
        helperText={(meta.touched && meta.error) || " "}
      >
        {!required && (
          <MenuItem value="">
            <em>Select gender</em>
          </MenuItem>
        )}
        {categories.map((category) => (
          <MenuItem key={category} value={category}>
            {category}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}

GenderField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  loading: PropTypes.bool,
  required: PropTypes.bool,
};
